import React, { FC, ComponentType, PropsWithChildren } from 'react'
import { Hidden } from '@mui/material'

import { getDisplayName } from '../../../service/util.service'

// eslint-disable-next-line @typescript-eslint/ban-types
const withHidden = <P extends object>(
  Component: ComponentType<P>,
  showOnMobile: boolean
): FC<PropsWithChildren<P>> => {
  const WithHidden: FC<PropsWithChildren<P>> = ({ children, ...props }) => (
    <Hidden mdUp={showOnMobile} mdDown={!showOnMobile}>
      <Component {...(props as P)}>{children}</Component>
    </Hidden>
  )

  WithHidden.displayName = `WithHidden(${getDisplayName(Component)})`

  return WithHidden
}

export default withHidden
